import { Button, Grid, Modal } from '@enterprise-ui/canvas-ui-react'

export const ConfirmationModal = ({ isVisible, onRefuse, onConfirm, file }) => {
  return (
    <>
      <Modal
        isVisible={isVisible}
        onRefuse={onRefuse}
        headingText="Confirm File Upload"
        className="hc-pa-expanded"
        size="dense"
      >
        <Grid.Container className="hc-pa-expanded">
          <Grid.Item xs={12}>
            Please ensure the selected file is correct. Once uploaded, the item
            data will be processed and updated in Launchpad.
          </Grid.Item>
          <Grid.Item xs={12} className="hc-mt-normal">
            <strong>Selected File:</strong>
            <span className="hc-pl-dense">{file?.name}</span>
            <p>
              <strong>File size:</strong>
              <span className="hc-pl-dense">{file?.size / 1000000} MB</span>
            </p>
          </Grid.Item>
          <Grid.Container
            justify="flex-end"
            className="hc-mt-dense hc-pr-expanded"
          >
            <Grid.Item xs={2.5}>
              <Button type="secondary" onClick={onRefuse}>
                Cancel
              </Button>
            </Grid.Item>
            <Grid.Item xs={2.5}>
              <Button type="primary" onClick={onConfirm}>
                Confirm
              </Button>
            </Grid.Item>
          </Grid.Container>
        </Grid.Container>
      </Modal>
    </>
  )
}
